import React from "react";
import "../../styles/About.css";
import { Link } from "react-router-dom";
const FurtherInformation = () => {
  return (
    <div className="about-container">
      <div className="about-title">
        <h3>Further Information</h3>
      </div>

      {/* Introduction Section */}
      <div className="cent-container">
        <div className="about-introduction">
          <p>
            After reading the appropriate material, for further information
            contact the appropriately{" "}
            <Link
              to="/ourcenters"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              trained individuals{" "}
            </Link>{" "}
            for someone who can provide the appropriate equipment in your
            country. If there is no one from your country, you may need to come
            here and be trained yourself or do the best you can with the
            equipment that you must obtain (most often a portable ventilator or
            BiPAP machine, oximeter, and Cough-Assist device) and with the
            information in the above book and the Bibliography.
          </p>
          <p>
            After reading the appropriate material, for further information
            contact the appropriately trained individuals for someone who can
            provide the appropriate equipment in your country. If there is no
            one from your country, you may need to come here and be trained
            yourself or do the best you can with the equipment that you must
            obtain (most often a portable ventilator or BiPAP machine, oximeter,
            and Cough-Assist device).
          </p>
          <p>
            Services are also available through{" "}
            <Link
              to="/ourcenters"
              style={{ textDecoration: "none", color: "darkblue" }}
            >
              The Center
            </Link>{" "}
            and MDA Clinic in New Jersey. In the United States, you may contact
            our trained respiratory therapist, Mr. Lou Saporito at beeper:
            1-973-466-9128 for questions, but please read the appropriate
            material first.
          </p>
          <p>
            It is strongly recommended that, when at all possible, patients
            contact Ms. Keisha Brady (bradykl@umdnj.edu) for an appointment and
            directions to the Jerry Lewis MDA Clinic.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FurtherInformation;
